import DocumentAllList from "../../components/Document/documenAlltList";

export default function Document(){
    return (
      <div>
        <DocumentAllList />
      </div>
    );
}
